import { CargoActivityType as ServerCargoActivityType } from 'server/models/CargoActivityType';

export * from 'server/models/CargoActivityType';

export class CargoActivityType extends ServerCargoActivityType {
    /** A comparator function for CargoActivityTypes. */
    static DisplayOrder(t1 : CargoActivityType, t2 : CargoActivityType) {
        let cmp : number;
        return (cmp = t1.DisplayOrder() - t2.DisplayOrder()) === 0 ?
            // If DisplayOrder matches, fallback to Id for a deterministic sort.
            t1.Id() - t2.Id() :
            cmp;
    }
}



// WEBPACK FOOTER //
// ./data/models/CargoActivityType.ts